import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

const PaymentTest = () => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [config, setConfig] = useState(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://app.fawaterk.com/fawaterkPlugin/fawaterkPlugin.min.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, []);

    const handlePayment = async () => {
        setLoading(true);
        setError(null);
        setResult(null);
        setConfig(null);

        try {
            const user = JSON.parse(localStorage.getItem('user'));
            if (!user) {
                setError('Please login first to test payment');
                setLoading(false);
                return;
            }

            // 1. Get Config from Backend
            const response = await api.post('/payment/pay', {
                amount: 50, // Test Amount
                name: user.name,
                email: user.email,
                phone: user.phone || '01000000000'
            });

            console.log('Payment Init Response:', response.data);

            if (response.data.success && response.data.data.mode === 'iframe') {
                const data = response.data.data;
                const user_data = data.user_data;

                setConfig(data);
                setResult('Config received. Initializing IFrame...');

                // 2. Prepare Plugin Config
                const pluginConfig = {
                    envType: "live", // Assuming live since app.fawaterk.com
                    hashKey: data.hash_key,
                    requestBody: {
                        cartTotal: "50",
                        currency: "EGP",
                        customer: {
                            first_name: "Test",
                            last_name: "User",
                            email: user_data.email,
                            phone: user_data.phone || '01000000000',
                            address: "Cairo, Egypt"
                        },
                        redirectionUrls: {
                            successUrl: `${window.location.origin}/api/payment/callback?userId=${user_data.id}`,
                            failUrl: `${window.location.origin}/api/payment/callback?userId=${user_data.id}`,
                            pendingUrl: `${window.location.origin}/api/payment/callback?userId=${user_data.id}`
                        },
                        cartItems: [{
                            name: "Test Item",
                            price: "50",
                            quantity: "1"
                        }]
                    }
                };

                // 3. Initialize Plugin
                if (window.fawaterkCheckout) {
                    window.fawaterkCheckout(pluginConfig);
                    setResult('IFrame Initialized. Check below.');
                } else {
                    setError('Fawaterak Plugin not loaded yet.');
                }

            } else {
                setError('Failed to get IFrame config: ' + JSON.stringify(response.data));
            }

        } catch (err) {
            console.error('Payment Test Error:', err);
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-8 bg-white dark:bg-slate-900 text-slate-900 dark:text-white rounded-xl max-w-lg mx-auto mt-10">
            <h2 className="text-xl font-bold mb-4">Fawaterak Payment Integration Test</h2>

            <div className="mb-6 space-y-2">
                <p className="text-sm text-slate-700 dark:text-slate-400">
                    This test will attempt to initialize the Fawaterak IFrame.
                </p>
                <div className="bg-white dark:bg-slate-800 p-4 rounded text-xs font-mono">
                    <p>Status: {loading ? 'Loading...' : 'Ready'}</p>
                    {config && <p className="text-green-400">Config: Loaded</p>}
                </div>
            </div>

            <button
                onClick={handlePayment}
                disabled={loading}
                className="w-full py-3 bg-blue-600 hover:bg-blue-500 rounded-lg font-bold disabled:opacity-50"
            >
                {loading ? 'Processing...' : 'Test Payment Setup'}
            </button>

            {error && (
                <div className="mt-4 p-3 bg-red-500/20 text-red-300 rounded border border-red-500/50">
                    Error: {error}
                </div>
            )}

            {result && (
                <div className="mt-4 p-3 bg-green-500/20 text-green-300 rounded border border-green-500/50">
                    {result}
                </div>
            )}

            {/* Fawaterak Plugin Target Div */}
            <div id="fawaterkDivId" className="mt-6 border border-dashed border-slate-600 p-4 rounded min-h-[200px] flex items-center justify-center text-slate-600 dark:text-slate-400">
                IFrame will load here
            </div>

            <div className="mt-8 pt-4 border-t border-slate-300 dark:border-slate-700 text-xs text-slate-600 dark:text-slate-400">
                <p>Note: Ensure you are logged in as a valid user before testing.</p>
            </div>
        </div>
    );
};

export default PaymentTest;
